const SvgSortArrow = () => {
  return (
    <svg
      className="drop-arrow"
      width="9"
      height="7"
      viewBox="0 0 9 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.34118 5.6915C4.94754 6.30382 4.05246 6.30382 3.65882 5.6915L0.990487 1.54076C0.562658 0.875247 1.0405 8.16942e-08 1.83167 1.43812e-07L7.16833 5.62818e-07C7.9595 6.24936e-07 8.43734 0.875247 8.00951 1.54076L5.34118 5.6915Z"
        className="fill-primary"
      />
    </svg>
  );
};

export default SvgSortArrow;
